function joinUrl(base, ...paths) {
  // Remove trailing slash from base if present
  if (base.endsWith("/")) {
    base = base.slice(0, -1);
  }

  // Join all paths and ensure single slashes between them
  const joinedPaths = paths
    .map((path) => {
      // Ensure path starts with a single slash
      if (path.startsWith("/")) {
        path = path.slice(1);
      }
      // Ensure path does not end with a slash
      if (path.endsWith("/")) {
        path = path.slice(0, -1);
      }
      return path;
    })
    .join("/");

  return `${base}/${joinedPaths}`;
}

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function getUserInfo() {
  const token = localStorage.getItem("token");

  if (!token) {
    return null;
  }

  try {
    const payloadBase64 = token.split(".")[1];
    const payloadJson = atob(payloadBase64); // Decode from Base64
    const payload = JSON.parse(payloadJson);

    return payload || null;
  } catch {
    return null;
  }
}

// Splash screen utilities
export const SPLASH_STORAGE_KEY = "hasSeenSplash";
export const SPLASH_STEP_KEY = "currentSplashStep";

export const hasSeenSplash = () => {
  return localStorage.getItem(SPLASH_STORAGE_KEY) === "true";
};

export const markSplashAsSeen = () => {
  localStorage.setItem(SPLASH_STORAGE_KEY, "true");
  localStorage.removeItem(SPLASH_STEP_KEY); // Clear step when marked as seen
};

export const resetSplashState = () => {
  localStorage.removeItem(SPLASH_STORAGE_KEY);
  localStorage.removeItem(SPLASH_STEP_KEY);
};

export const getCurrentSplashStep = () => {
  const step = localStorage.getItem(SPLASH_STEP_KEY);
  return step ? parseInt(step, 10) : 1;
};

export const setCurrentSplashStep = (step) => {
  localStorage.setItem(SPLASH_STEP_KEY, step.toString());
};

export { joinUrl, capitalizeFirstLetter, getUserInfo };
